import { combineReducers } from "redux";

import auth from "./auth";
import users from "./users";
import courses from "./courses.js";
import downloads from "./downloads";
import groups from "./groups.js";
import holidays from "./holidays.js";
import invoices from "./invoices.js";
import payments from "./payments.js";
import posts from "./posts.js";
import students from "./students.js";
import subjects from "./subjects.js";
import teachers from "./teachers.js";
import search from "./search.js";
import tables from "./tables.js";
import ui from "./ui.js";
import members from "./members.js";
import membership_payments from "./membership_payments.js";

export default combineReducers({
    auth,
    users,
    courses,
    downloads,
    groups,
    holidays,
    invoices,
    payments,
    posts,
    students,
    subjects,
    teachers,
    search,
    tables,
    ui,
    members,
    membership_payments,
});
